/* Tea Apothecary theme, by The Naked Ad. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const TA = window.TA || {};

  /* ---------- Money ---------- */
  const money = (cents) => {
    const f = TA.moneyFormat || '£{{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
      k === 'amount_no_decimals' ? Math.round(v).toString() :
      k === 'amount_with_comma_separator' ? two.replace('.', ',') : two.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  };

  /* ---------- Toast ---------- */
  let toastT;
  const toast = (msg) => {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(() => { t.hidden = true; }, 3200);
  };
  TA.toast = toast;

  /* ---------- Header: scrolled state + owl sip ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', scrollY > 40);
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
    if (header.classList.contains('will-sip') && !reduce) {
      addEventListener('load', () => setTimeout(() => header.classList.add('sip'), 400), { once: true });
    }
  }

  /* ---------- Mobile menu ---------- */
  const menuBtn = $('#menuBtn'), mmenu = $('#mmenu');
  if (menuBtn && mmenu) {
    menuBtn.addEventListener('click', () => {
      const open = mmenu.hidden;
      mmenu.hidden = !open; menuBtn.setAttribute('aria-expanded', open);
      document.body.classList.toggle('menu-open', open);
    });
  }

  /* ---------- Announcement ticker ---------- */
  $$('[data-ticker]').forEach((bar) => {
    const ticks = $$('.tick', bar); if (ticks.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => { ticks[i].classList.remove('on'); i = (i + 1) % ticks.length; ticks[i].classList.add('on'); }, 4500);
  });

  /* ---------- Rewards (Smile) ---------- */
  document.addEventListener('click', (e) => {
    const r = e.target.closest('[data-rewards]'); if (!r) return;
    e.preventDefault();
    // Smile's full SDK exposes SmileUI.openPanel(); the "lite" loader this store uses opens
    // its panel from the #smile-home deep link instead (cleared first so it re-triggers).
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') { window.SmileUI.openPanel(); return; }
    if (document.getElementById('smile-ui-lite-container') || window.__smile_ui_init_data__) {
      if (location.hash === '#smile-home') history.replaceState(null, '', location.pathname + location.search);
      location.hash = 'smile-home';
      return;
    }
    location.href = '/account';
  });

  /* ---------- Bag ---------- */
  const drawerSection = () => $('#shopify-section-cart-drawer');
  const openDrawer = () => {
    const d = $('[data-drawer]'), s = $('[data-scrim]'); if (!d) return false;
    d.classList.add('on'); s && s.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open'); d.focus({ preventScroll: true }); return true;
  };
  const closeDrawer = () => {
    const d = $('[data-drawer]'), s = $('[data-scrim]'); if (!d) return;
    d.classList.remove('on'); s && s.classList.remove('on'); d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  };
  const setCount = (n) => $$('[data-cart-count]').forEach((c) => { c.textContent = n; c.hidden = !n; });
  const refreshDrawer = async (html) => {
    if (!html) {
      const r = await fetch(`${TA.routes.root}?sections=cart-drawer`);
      html = (await r.json())['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const nb = $('[data-drawer-body]', doc), ob = $('[data-drawer-body]');
    // What the customer has ticked or typed wins over the re-rendered copy (a save may still be in flight).
    const oldGift = ob && $('[data-giftbox]', ob), newGift = nb && $('[data-giftbox]', nb);
    if (oldGift && newGift) {
      $('[data-gift-toggle]', newGift).checked = $('[data-gift-toggle]', oldGift).checked;
      $('[data-gift-fields]', newGift).hidden = $('[data-gift-fields]', oldGift).hidden;
      $('[data-gift-note]', newGift).value = $('[data-gift-note]', oldGift).value;
      $('[data-gift-note]', newGift).disabled = $('[data-gift-note]', oldGift).disabled;
      $('[data-gift-count]', newGift).textContent = $('[data-gift-note]', oldGift).value.length;
    }
    if (nb && ob) ob.replaceWith(nb);
    const c = $('[data-cart-count-src]', doc); if (c) setCount(+c.textContent);
  };
  const addToCart = async (items, btn) => {
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(TA.routes.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer' }) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Sorry, that could not be added.'); return; }
      await refreshDrawer(data.sections && data.sections['cart-drawer']);
      if (!openDrawer()) toast('Added to your bag');
      document.dispatchEvent(new CustomEvent('ta:cart-added', { detail: data }));
    } catch (err) { toast('Sorry, something went wrong. Please try again.'); }
    finally { btn && btn.removeAttribute('aria-busy'); }
  };
  const addFormToCart = async (form, btn) => {
    btn && btn.setAttribute('aria-busy', 'true');
    try {
      const fd = new FormData(form);
      fd.delete('variant-pick'); fd.append('sections', 'cart-drawer');
      if (!fd.get('selling_plan')) fd.delete('selling_plan');
      const r = await fetch(TA.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await r.json();
      if (!r.ok) { toast(data.description || data.message || 'Sorry, that could not be added.'); return; }
      await refreshDrawer(data.sections && data.sections['cart-drawer']);
      if (!openDrawer()) toast('Added to your bag');
      document.dispatchEvent(new CustomEvent('ta:cart-added', { detail: data }));
    } catch (err) { toast('Sorry, something went wrong. Please try again.'); }
    finally { btn && btn.removeAttribute('aria-busy'); }
  };
  const changeLine = async (key, quantity) => {
    const r = await fetch(TA.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer' }) });
    const data = await r.json();
    if (!r.ok) { toast(data.description || 'Could not update your bag.'); return; }
    await refreshDrawer(data.sections && data.sections['cart-drawer']);
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawerSection()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-scrim]')) { closeDrawer(); return; }
    const q = e.target.closest('[data-drawer] [data-qty]');
    if (q) { const line = q.closest('[data-line]'); changeLine(line.dataset.line, Math.max(0, +q.dataset.qty)); return; }
    const add = e.target.closest('[data-add]');
    if (add && !add.disabled) { e.preventDefault(); addToCart([{ id: +add.dataset.add, quantity: 1 }], add); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawer(); closeSearch(); closeMap();
  });

  /* ---------- Gift message (saved to the cart note + "Gift" attribute) ---------- */
  let giftTimer, giftSaving = Promise.resolve();
  const saveGift = (box) => {
    const on = $('[data-gift-toggle]', box).checked;
    const note = on ? $('[data-gift-note]', box).value.trim() : '';
    giftSaving = fetch(TA.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note, attributes: { Gift: on ? 'Yes' : '' } }) }).catch(() => {});
    return giftSaving;
  };
  const flushGift = () => { const box = $('[data-giftbox]'); if (giftTimer && box) { clearTimeout(giftTimer); giftTimer = null; saveGift(box); } return giftSaving; };
  document.addEventListener('change', (e) => {
    const t = e.target.closest('[data-gift-toggle]'); if (!t) return;
    const box = t.closest('[data-giftbox]');
    $('[data-gift-fields]', box).hidden = !t.checked;
    $('[data-gift-note]', box).disabled = !t.checked;
    if (t.checked) setTimeout(() => $('[data-gift-note]', box).focus(), 30);
    clearTimeout(giftTimer); giftTimer = null; saveGift(box);
  });
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-gift-note]'); if (!n) return;
    const box = n.closest('[data-giftbox]');
    $('[data-gift-count]', box).textContent = n.value.length;
    clearTimeout(giftTimer); giftTimer = setTimeout(() => { giftTimer = null; saveGift(box); }, 500);
  });
  // Make sure the latest message is saved before leaving for checkout.
  document.addEventListener('submit', async (e) => {
    const f = e.target; if (!f.querySelector('[name=checkout]') || f.dataset.giftReady) return;
    if (!$('[data-giftbox]')) return;
    e.preventDefault(); await flushGift();
    f.dataset.giftReady = '1';
    const btn = f.querySelector('button[name=checkout]');
    if (f.requestSubmit) f.requestSubmit(btn); else f.submit();
  });

  /* ---------- Card Pouch / Gift tub switch ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.seg button'); if (!b) return;
    const card = b.closest('[data-card]');
    $$('.seg button', card).forEach((x) => x.setAttribute('aria-pressed', x === b));
    const p = $('[data-card-price]', card); if (p) p.textContent = b.dataset.price;
    const add = $('[data-add]', card);
    if (add) { add.dataset.add = b.dataset.variant; add.disabled = b.hasAttribute('data-soldout'); add.textContent = add.disabled ? 'Sold out' : 'Add'; }
  });

  /* ---------- Gift budgets ---------- */
  $$('[data-gifts]').forEach((panel) => {
    panel.addEventListener('click', (e) => {
      const chip = e.target.closest('.chip'); if (!chip) return;
      $$('.chip', panel).forEach((c) => c.setAttribute('aria-pressed', c === chip));
      const [lo, hi] = chip.dataset.b === 'all' ? [0, Infinity] : chip.dataset.b.split('-').map(Number);
      $$('[data-card]', panel).forEach((card) => { const p = +card.dataset.price; card.hidden = !(p >= lo && p < hi); });
    });
  });

  /* ---------- Moving product row ---------- */
  $$('[data-carousel]').forEach((wrap) => {
    const track = $('[data-carousel-track]', wrap); if (!track) return;
    const section = wrap.closest('.shopify-section') || document;
    let paused = false, resumeT, last = 0, pos = 0, visible = true;
    const pause = (ms) => { paused = true; clearTimeout(resumeT); if (ms) resumeT = setTimeout(() => { paused = false; pos = track.scrollLeft; }, ms); };
    const resume = () => { clearTimeout(resumeT); resumeT = setTimeout(() => { paused = false; pos = track.scrollLeft; }, 600); };
    const step = () => { const c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 18 : 300; };
    $('[data-carousel-prev]', section)?.addEventListener('click', () => { pause(4000); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    $('[data-carousel-next]', section)?.addEventListener('click', () => { pause(4000); track.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (!wrap.classList.contains('is-moving') || reduce) return;
    // Clone the set once so the drift can loop without a visible jump.
    const originals = Array.from(track.children);
    if (originals.length < 3) return;
    originals.forEach((n) => { const c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', ''); track.appendChild(c); });
    const secs = parseFloat(getComputedStyle(wrap).getPropertyValue('--speed')) || 70;
    // Start a couple of cards in, so the row is already full width rather than drifting
    // away from an empty left margin.
    pos = (parseFloat(getComputedStyle(track).paddingLeft) || 0) + step() * 2;
    track.scrollLeft = pos;
    wrap.addEventListener('pointerenter', () => pause()); wrap.addEventListener('pointerleave', resume);
    wrap.addEventListener('focusin', () => pause()); wrap.addEventListener('focusout', resume);
    wrap.addEventListener('touchstart', () => pause(5000), { passive: true });
    new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(wrap);
    const tick = (t) => {
      const dt = last ? Math.min(t - last, 64) : 16; last = t;
      if (!paused && visible && !document.hidden) {
        const half = track.scrollWidth / 2;
        pos += (half / secs) * (dt / 1000);
        if (pos >= half) pos -= half;
        track.scrollLeft = pos;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });

  /* ---------- Search ---------- */
  const search = $('[data-search]');
  const openSearch = () => {
    if (!search) return;
    // Line the search box up with the top of the header, below the announcement bar.
    const h = $('.header-section') || header;
    search.style.setProperty('--search-top', `${Math.max(0, h ? h.getBoundingClientRect().top : 0)}px`);
    search.hidden = false; setTimeout(() => $('[data-search-input]', search).focus(), 30); };
  function closeSearch() { if (search) search.hidden = true; }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]') || e.target === search) closeSearch();
  });
  if (search) {
    const input = $('[data-search-input]', search), out = $('[data-search-results]', search);
    let ctrl, t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${TA.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`, { signal: ctrl.signal });
          const d = await r.json();
          const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          out.innerHTML = ps.length ? ps.map((p) => `<a href="${p.url}">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=120" alt="" width="48" height="48">` : '<span></span>'}<span>${p.title}<br><small>${p.type || ''}</small></span><span>${money(Math.round(parseFloat(p.price) * 100))}</span></a>`).join('') + `<a class="all" href="/search?type=product&q=${encodeURIComponent(q)}"><span></span><span>See all results for “${q.replace(/</g, '&lt;')}”</span><span>&rarr;</span></a>`
            : `<p class="none">No teas match “${q.replace(/</g, '&lt;')}”. Try a flavour or a type, like vanilla or green.</p>`;
        } catch (err) { /* aborted */ }
      }, 180);
    });
  }

  /* ---------- Map ---------- */
  function closeMap() { $$('[data-map]').forEach((m) => { m.hidden = true; }); }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-map-open]')) {
      const m = $('[data-map]'); if (!m) return;
      const f = $('iframe', m); if (f && !f.src) f.src = f.dataset.src;
      m.hidden = false; $('[data-map-close]', m).focus();
    }
    if (e.target.closest('[data-map-close]') || e.target.matches('[data-map]')) closeMap();
  });

  /* ---------- Collection sort ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
  }));

  /* ---------- Klaviyo sign-ups ---------- */
  const kHeaders = { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' };
  TA.subscribe = async (email, source, properties) => {
    const k = TA.klaviyo || {};
    if (!k.company || !k.list) throw new Error('Klaviyo is not set up in theme settings');
    const base = 'https://a.klaviyo.com/client/';
    const qs = `?company_id=${encodeURIComponent(k.company)}`;
    const r = await fetch(`${base}subscriptions/${qs}`, { method: 'POST', headers: kHeaders, body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email } } } }, relationships: { list: { data: { type: 'list', id: k.list } } } } }) });
    if (!r.ok && r.status !== 202) throw new Error('Subscribe failed');
    if (properties && Object.keys(properties).length) {
      // Saved separately so a profile update can never block the sign-up itself. Sent again
      // a moment later in case Klaviyo is still creating the profile from the subscription;
      // keepalive lets it finish even if the page has moved on to the tea.
      const saveProps = () => fetch(`${base}profiles/${qs}`, { method: 'POST', headers: kHeaders, keepalive: true, body: JSON.stringify({ data: { type: 'profile', attributes: { email, properties } } }) }).catch(() => {});
      saveProps(); setTimeout(saveProps, 2500);
    }
    return true;
  };
  TA.track = (email, metric, properties) => {
    const k = TA.klaviyo || {}; if (!k.company || !email) return;
    fetch(`https://a.klaviyo.com/client/events/?company_id=${encodeURIComponent(k.company)}`, { method: 'POST', headers: kHeaders, body: JSON.stringify({ data: { type: 'event', attributes: { properties: properties || {}, metric: { data: { type: 'metric', attributes: { name: metric } } }, profile: { data: { type: 'profile', attributes: { email } } } } } }) }).catch(() => {});
  };
  const validEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  $$('[data-klaviyo-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = form.email.value.trim(), msg = $('[data-form-msg]', form);
      if (!validEmail(email)) { msg.textContent = 'Please enter a valid email address.'; form.email.focus(); return; }
      const btn = $('button[type=submit]', form); btn.disabled = true;
      try {
        await TA.subscribe(email, form.dataset.source || 'Website');
        form.classList.add('is-done');
        msg.textContent = `Thank you! ${TA.welcome && TA.welcome.offer ? `Your ${TA.welcome.offer} code is on its way to your inbox.` : 'You’re on the list.'}`;
      } catch (err) { msg.textContent = 'Sorry, that didn’t work. Please try again.'; btn.disabled = false; }
    });
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach((root) => {
    const jsonEl = root.parentElement.querySelector('[data-product-json]') || $('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('[data-variant-id]', root);
    const priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), perEl = $('[data-per]', root);
    const btn = $('[data-add-btn]', root), btnPrice = () => $('[data-btn-price]', root);
    const mainImg = $('[data-main-img]', root);
    const sticky = $('[data-sticky-atc]'), stickySub = $('[data-sticky-sub]'), stickyAdd = $('[data-sticky-add]');
    const qty = $('[data-qty-input]', root);
    let variant = product.variants.find((v) => v.id === +idInput.value) || product.variants[0];

    const gramsOf = (v) => { const m = (v.title || '').match(/(\d+)\s*g\b/i); return m ? +m[1] : 0; };
    const showMedia = (id, src, srcset) => {
      if (!mainImg) return;
      if (src) { mainImg.src = src; if (srcset) mainImg.srcset = srcset; }
      $$('.thumbs button', root).forEach((b) => b.setAttribute('aria-pressed', String(+b.dataset.mediaId === id)));
    };
    const render = () => {
      idInput.value = variant.id;
      priceEl.textContent = money(variant.price);
      if (compareEl) { compareEl.hidden = !(variant.compare_at_price > variant.price); compareEl.textContent = variant.compare_at_price ? money(variant.compare_at_price) : ''; }
      const g = gramsOf(variant);
      // Price per 100g and roughly how many cups (about 2.5g of leaves per cup).
      if (perEl) perEl.textContent = g && product.type && !/gift|teaware/i.test(product.type) ? `${money(Math.round(variant.price * 100 / g))} per 100g · about ${Math.round(g / 2.5)} cups` : '';
      btn.disabled = !variant.available;
      btn.innerHTML = variant.available ? `Add to bag · <span data-btn-price>${money(variant.price)}</span>` : 'Sold out';
      if (stickySub) stickySub.textContent = `${product.variants.length > 1 ? variant.title + ' · ' : ''}${money(variant.price)}`;
      if (stickyAdd) stickyAdd.disabled = !variant.available;
      if (variant.featured_media) {
        const b = $(`.thumbs button[data-media-id="${variant.featured_media.id}"]`, root);
        showMedia(variant.featured_media.id, b && b.dataset.src, b && b.dataset.srcset);
      }
      const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState(null, '', u);
    };
    root.addEventListener('change', (e) => {
      if (e.target.name === 'variant-pick') { variant = product.variants.find((v) => v.id === +e.target.value) || variant; render(); }
      if (e.target.dataset.option !== undefined) {
        const picked = product.options.map((_, i) => { const c = $(`input[data-option="${i}"]:checked`, root); return c ? c.value : null; });
        const match = product.variants.find((v) => v.options.every((o, i) => o === picked[i]));
        if (match) { variant = match; render(); } else { btn.disabled = true; btn.textContent = 'Unavailable'; }
      }
    });
    render();
    // Seal Subscriptions draws its one-off / subscribe box at the top of the form. Move it
    // under the format cards (where the concept had the choice) whenever it appears.
    const addrow = $('.addrow', form);
    const placeSeal = () => {
      const seal = $(':scope > .sealsubs-target-element', form);
      if (seal && addrow && seal.nextElementSibling !== addrow) form.insertBefore(seal, addrow);
    };
    placeSeal();
    new MutationObserver(placeSeal).observe(form, { childList: true });
    $$('.thumbs button', root).forEach((b) => b.addEventListener('click', () => showMedia(+b.dataset.mediaId, b.dataset.src, b.dataset.srcset)));
    $$('[data-qty-step]', root).forEach((b) => b.addEventListener('click', () => { qty.value = Math.max(1, (+qty.value || 1) + +b.dataset.qtyStep); }));
    // Send the whole form so apps that add fields (Seal Subscriptions' selling_plan, line
    // item properties from gift apps) reach the cart too.
    const submitForm = (b) => { idInput.value = variant.id; addFormToCart(form, b); };
    form.addEventListener('submit', (e) => { e.preventDefault(); submitForm(btn); });
    if (stickyAdd) stickyAdd.addEventListener('click', () => submitForm(stickyAdd));
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('show', show); sticky.setAttribute('aria-hidden', String(!show));
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('sticky-on', show);
      }).observe(btn);
    }
  });

  /* Recommendations load after the page */
  $$('[data-recos]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const r = await fetch(el.dataset.url); const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recos]', doc); if (fresh && fresh.children.length) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* no recommendations */ }
  });

  /* ---------- Quiz ---------- */
  $$('[data-quiz]').forEach((quiz) => {
    const screens = $$('.q-screen', quiz);
    const qs = $$('[data-q]', quiz);
    const modal = $('[data-q-modal]');
    let answers = [], current = -1, chosen = null;
    const show = (el) => {
      screens.forEach((s) => { s.hidden = s !== el; s.classList.toggle('is-on', s === el); });
      const h = $('h1, h2', el); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
      const top = quiz.getBoundingClientRect().top + scrollY - 90;
      if (scrollY > top) scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
    };
    const ask = (i) => { current = i; show(qs[i]); $$('.q-ans', qs[i]).forEach((b) => b.setAttribute('aria-pressed', String(answers[i] === b.dataset.letter))); };
    const finish = () => {
      // Mostly-letter wins; on a tie, the most recently picked of the tied letters wins.
      const tally = {}; answers.forEach((l) => { tally[l] = (tally[l] || 0) + 1; });
      const top = Math.max(...Object.values(tally));
      const tied = Object.keys(tally).filter((l) => tally[l] === top);
      let win = tied[0];
      for (let i = answers.length - 1; i >= 0; i--) { if (tied.includes(answers[i])) { win = answers[i]; break; } }
      const res = $(`[data-result="${win}"]`, quiz) || $('[data-result]', quiz);
      chosen = res; show(res);
    };
    $('[data-q-start]', quiz)?.addEventListener('click', () => { answers = []; ask(0); });
    quiz.addEventListener('click', (e) => {
      const a = e.target.closest('.q-ans');
      if (a) { answers[current] = a.dataset.letter; answers.length = current + 1; current < qs.length - 1 ? ask(current + 1) : finish(); return; }
      if (e.target.closest('[data-q-back]')) { current > 0 ? ask(current - 1) : show($('[data-q-intro]', quiz)); return; }
      if (e.target.closest('[data-q-restart]')) { answers = []; ask(0); return; }
      const shop = e.target.closest('[data-q-shop], [data-q-shop-link]');
      if (shop) { e.preventDefault(); openOffer(); }
    });
    const result = () => { const b = chosen && $('[data-q-shop]', chosen); return b ? { url: b.dataset.url, tea: b.dataset.tea, persona: b.dataset.persona } : { url: '/collections' }; };
    const go = () => { location.href = result().url; };
    const openOffer = () => {
      if (!modal) return go();
      modal.hidden = false; $('[data-q-form-wrap]', modal).hidden = false; $('[data-q-done]', modal).hidden = true;
      setTimeout(() => $('input[type=email]', modal).focus(), 30);
    };
    if (!modal) return;
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-q-skip]') || e.target.closest('[data-q-go]')) go();
      else if (e.target === modal) modal.hidden = true;
    });
    $('[data-q-form]', modal).addEventListener('submit', async (e) => {
      e.preventDefault();
      const f = e.currentTarget, msg = $('[data-form-msg]', f), email = f.email.value.trim();
      if (!validEmail(email)) { msg.textContent = 'Please enter a valid email address.'; f.email.focus(); return; }
      if (!f.consent.checked) { msg.textContent = 'Please tick the box to agree to receive our emails.'; return; }
      const btn = $('button[type=submit]', f); btn.disabled = true; msg.textContent = '';
      const r = result();
      try {
        await TA.subscribe(email, 'Tea quiz', { 'Tea personality': r.persona, 'Quiz tea': r.tea });
        TA.track(email, 'Completed Tea Quiz', { 'Tea personality': r.persona, 'Quiz tea': r.tea, url: r.url });
        $('[data-q-form-wrap]', modal).hidden = true; $('[data-q-done]', modal).hidden = false;
        $('[data-q-go]', modal).focus();
        setTimeout(go, 4000);
      } catch (err) { msg.textContent = 'Sorry, that didn’t work. Please try again, or skip for now.'; btn.disabled = false; }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) modal.hidden = true; });
  });
})();
